import React from 'react';
import styled from 'styled-components/macro';
import LayoutResultados from '../components/LayoutResultados';
import TablaTerritorios from './TablaTerritorios/TablaTerritorios';
import ResumenPorTerritorios from './Graficas/Territorios/ResumenTerritorios';
import { useEleccion } from '../contexts/eleccionContext';
import ContenedorSelectorCamaras from './ContenedorSelectorCamaras';
import { responsive } from '../resources/constantes.json';
import useWindowWidth from '../hooks/useWindowWidth';

const ResultadosTerritorios = ({ ambito }) => {
  const elecOptions = useEleccion();
  const windowWidth = useWindowWidth().width;
  return (
    <MainContainer key={windowWidth}>
      <ContenedorSelectorCamaras />
      <ContentContainer>
        <LayoutResultados
          leftComponent={
            <TablaTerritorios
              ambito={ambito}
              camaraSeleccionada={elecOptions.selectedCamara}
            />
          }
          rightComponent={
            <ResumenPorTerritorios
              camaraSeleccionada={elecOptions.selectedCamara}
            />
          }
        />
      </ContentContainer>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  background: #fff;
`;

const ContentContainer = styled.div`
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 16px;
  @media screen and (max-width: ${responsive.mobile}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
export default ResultadosTerritorios;
